<template>
  <div class="d-flex flex-column ga-8">
    <div class="">
      <div class="d-flex align-center justify-space-between">
        <p>{{ $t('jaar') }}</p>
        <p>{{ $t('gebruikt-totaal') }}</p>
      </div>

      <div v-if="loading" class="d-flex flex-column ga-4 mt-6">
        <div v-for="i in 4" :key="i" class="">
          <v-skeleton-loader type="list-item" />
        </div>
      </div>

      <div v-else class="d-flex flex-column ga-4 mt-6">
        <div v-for="(credit, index) in credits" :key="index" class="">
          <div class="d-flex align-center justify-space-between">
            <p class="text-bold text-capitalize">{{ credit.year }}</p>
            <p>{{ credit.credits }}/{{ max }}</p>
          </div>

          <v-progress-linear class="rounded-sm" :max="max" :model-value="credit.credits" color="var(--company-primary)"></v-progress-linear>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreditsService from "../../../services/CreditsService";
import { useMainStore } from "../../../stores/store";
export default {
  data() {
    return {
      mainStore: useMainStore(),
      loading: true,

      credits: [],
    };
  },

  props: {
    max: {
      type: Number,
      required: true,
    }
  },

  mounted() {
    this.getCredits();
  },

  computed: {
    years() {
      const currentYear = new Date().getFullYear();

      // make an array of this year and the next 3 years
      const years = [];
      for (let i = 0; i < 4; i++) {
        years.push({ name: currentYear + i });
      }
      return years;
    },
  },

  methods: {
    async getCredits() {
      try {
        const response = await CreditsService.getYearlyCredits();

        if (response) {
          this.credits = response.data.data;
          console.log("CREDITSSSSS", this.credits);
          this.loading = false;
        }
      } catch (error) {
        console.error("Error getting credits", error);
        this.$toast.error("Er is iets fout gegaan bij het ophalen van de credits");
      }
    },
  },
};
</script>
